<template>
  <div class="mod-mobile-employee-info">
    <div class="mod-header">
      <h5 class="main-title">赋能企业数字化转型</h5>
      <p class="sub-title">注册员工账号</p>
      <p class="sub-tips">请完善您的信息，便于管理员审核</p>
    </div>
    <van-form ref="form" class="register-info-form" @submit="onSubmit">
      <van-field
        v-model.trim="department"
        maxlength="20"
        placeholder="请输入部门名称"
        @focus="handlerFocus"
        @blur="handlerBlur"
      />
      <van-field
        readonly
        name="picker"
        :value="sex"
        placeholder="请选择性别"
        @click="showPicker = true"
      />
      <van-field
        v-model.trim="employeeNo"
        maxlength="10"
        placeholder="请输入员工工号"
        @focus="handlerFocus"
        @blur="handlerBlur"
      />
      <van-field
        v-model.trim="email"
        maxlength="50"
        placeholder="请输入邮箱地址"
        @focus="handlerFocus"
        @blur="(e) => {
          handlerBlur(e)
          checkEamil(e)
        }"
        :error-message="emailErrMsg"
      />
      <van-field class="img-code-input" :error-message="codeErrMsg">
        <template #input>
          <div class="mod-input-code-box">
            <input class="input-code" @focus="handlerFocus" @input="() => { checkMsg= '' }" @blur="(e) => {
              handlerBlur(e)
              checkCode(e)
            }" placeholder="请输入验证码" v-model.trim="code" maxlength="4" />
            <img class="code-img" @click="onfreshCode" :src="imageCodeUrl" />
          </div>
        </template>
      </van-field>
      <van-button block type="info" class="m-register-btn"  :loading="loading"  loading-text="提交中..." native-type="submit" >
        提交
      </van-button>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="sexIndex"
        :columns="['男','女']"
        @confirm="onConfirmsex"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Api from '@/pc_login/api.js'
import { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Toast)
export default {
  data () {
    return {
      department: '',
      sex: '',
      employeeNo: '',
      email: '',
      emailErrMsg: '',
      code: '',
      codeErrMsg: '',
      checkMsg: null,
      sexIndex: null,
      imageCodeUrl: '',
      showPicker: false,
      loading: false,
      guuid: null,
      empRegId: null
    }
  },
  mounted () {
    this.empRegId = this.$attrs.id
    this.onfreshCode()
  },
  methods: {
    handlerFocus (el) {
      setTimeout(() => {
        if (el.target.scrollIntoView) {
          el.target.scrollIntoView(false)
        } else {
          document.body.scrollTop = document.body.scrollHeight
        }
      }, 100)
    },
    handlerBlur (el) {
      if (!el.target.scrollIntoView) {
        var ua = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(ua)) {
          var currentPosition
          var speed = 1
          setTimeout(() => {
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= speed
            window.scrollTo(0, currentPosition)
            currentPosition += speed
            window.scrollTo(0, currentPosition)
          }, 1)
        }
      }
    },
    onConfirmsex (val) {
      this.sex = val
      this.showPicker = false
    },
    onfreshCode () {
      Api.getImageCode().then(res => {
        this.imageCodeUrl && (window.URL || window.webkitURL || window.mozURL).revokeObjectURL(this.imageCodeUrl)
        this.guuid = res.headers.uuid
        this.imageCodeUrl = (window.URL || window.webkitURL || window.mozURL).createObjectURL(res.data)
      }).catch(({ response }) => {
        Api.message(Toast, response)
      })
    },
    checkEamil (e) {
      const callback = typeof e === 'function' ? e : ''
      if (this.email && !/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(this.email)) {
        this.emailErrMsg = '格式不正确！'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.emailErrMsg = ''
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      }
    },
    checkCode (e) {
      const callback = typeof e === 'function' ? e : ''
      if (this.checkMsg) {
        this.codeErrMsg = this.checkMsg
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if ((this.department || this.sex || this.employeeNo || this.email) && !this.code) {
        this.codeErrMsg = '请输入验证码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.codeErrMsg = ''
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      }
    },
    onSubmit () {
      this.checkEamil((v) => {
        this.checkCode((val) => {
          if (v && val) {
            if (this.department || this.sex || this.employeeNo || this.email) {
              this.loading = true
              Api.addEmployeeInfo({
                'empRegId': this.empRegId,
                'department': this.department || '',
                'sex': this.sex === '男' ? '1' : this.sex === '女' ? '0' : '',
                'empNo': this.employeeNo || '',
                'email': this.email || '',
                'code': this.code,
                'uuid': this.guuid
              }).then(res => {
                this.$emit('change', 'result')
              }).catch(({ response }) => {
                if (response && response.status === 406 && response.data && (response.data.msg === '验证码错误！' || response.data.msg === '验证码已失效,请重新获取' || response.data.msg === '验证码已失效,请重新获取')) {
                  this.checkMsg = response.data.msg
                  this.checkCode()
                } else {
                  Api.message(Toast, response)
                }
                this.onfreshCode()
              }).finally(() => {
                this.loading = false
              })
            } else {
              this.$emit('change', 'result')
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="less">
.mod-mobile-employee-info{
  background-color: #F6F8FB;
  min-height: 100vh;
  text-align: center;
  .mod-header{
    width: 100%;
    height: 205px;
    margin: 0 auto;
    position: relative;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('/imgs/m_header.png');
    background-color: transparent;
    .main-title{
      font-size: 24px;
      color: #FFFFFF;
      height: 33px;
      line-height: 33px;
      margin: 0 auto;
      padding-top: 40px;
      font-weight: 600;
      text-align: center;
      box-sizing: content-box;
    }
    .sub-title{
      font-size: 15px;
      color: #FFFFFF;
      height: 22px;
      line-height: 22px;
      text-align: center;
      padding-top: 8px;
    }
    .sub-tips{
      font-size: 14px;
      color: #666;
      height: 19px;
      line-height: 19px;
      text-align: left;
      text-indent: 30px;
      padding-top: 74px;
    }
  }
  .register-info-form{
    margin: 0px 30px 0;
   .van-field__control {
      color: #333 ;
      background-color: transparent;
      &::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
        }
    }
    input::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
    .van-cell {
      background-color: #F6F8FB;
      border-radius: 4px;
      padding: 0;
      &::after{
        border-bottom:none;
      }
      &+.van-cell {
        margin-top: 20px;
      }
      .van-field__control{
        padding: 10px 16px;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        &:focus, &:active{
          outline: none;
          border-color: #409eff;
        }
      }
      &.img-code-input .van-field__control{
        padding: 0;
        background-color: #F6F8FB;
        padding: 0;
        background-color: #F6F8FB;
        border: none;
        border-radius: 0;
        height: 46px;
        .mod-input-code-box{
          position: relative;
          width: 100%;
          box-sizing: border-box;
          padding-right: 110px;
          .input-code{
            padding: 10px 16px;
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            box-sizing: border-box;
            width: 100%;
            &:focus, &:active{
              outline: none;
              border-color: #409eff;
            }
          }
          .code-img{
            position: absolute;
            right: 0;
            top: 0px;
            height: 46px;
            width: 100px;
            border-radius: 4px;
          }
        }
      }
      &.mod-input-mobile-code-box .van-field__button{
        position: absolute;
        top: 4px;
        right: 10px;
        padding: 0;
      }
    }
  }
  .m-register-btn {
    margin: 30px 0px 0;
    border-radius: 6px;
  }
}
</style>
